import {
  GRANT_TYPE_LDAP,
  COOKIE_AUTH,
  COOKIE_SPOOFER_TOKEN,
  COOKIE_LOGGEDIN,
} from '@homeservices/skeleton-key';
import { getCookie, eraseCookie } from '@/utils/cookies';

function getLDAPUser () {
  const token = getCookie(COOKIE_SPOOFER_TOKEN);
  // spoofer token exists, LDAP user must be loggedin
  if (token) {
    return token;
  }

  // maybe user is logged-in but not spoofing anyone
  const normalToken = getCookie(COOKIE_AUTH);
  // Ok there is a token but is it an LDAP token?
  if (normalToken) {
    if (normalToken.grant_type === GRANT_TYPE_LDAP) {
      return normalToken; // an LDAP user us loggedin
    }
  }

  return false;
}

export default {
  namespaced: true,
  state () {
    return {
      isLDAPLoggedIn: null,
      isSpoofed: null,
      ldapUsername: '',
      currentUsername: '',
    };
  },
  getters: {
    isLDAPLoggedIn (state) {
      return state.isLDAPLoggedIn;
    },
  },
  actions: {
    async logout () {
      await eraseCookie(COOKIE_SPOOFER_TOKEN);
      await eraseCookie(COOKIE_AUTH);
      await eraseCookie(COOKIE_LOGGEDIN);
      await window.location.replace('/identity/logout');
    },
    update ({ commit }) {
      const LDAPUser = getLDAPUser();
      const token = getCookie(COOKIE_AUTH);

      commit('update', {
        isLDAPLoggedIn: Boolean(LDAPUser),
        isSpoofed: Boolean(getCookie(COOKIE_SPOOFER_TOKEN)),
        ldapUsername: LDAPUser.username,
        currentUsername: token ? `${token.first_name} ${token.last_name}` : '',
      });
    },
  },
  mutations: {
    update (state, payload) {
      state.isLDAPLoggedIn = payload.isLDAPLoggedIn;
      state.isSpoofed = payload.isSpoofed;
      state.ldapUsername = payload.ldapUsername;
      state.currentUsername = payload.currentUsername;
    },
  },
};
